import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { MessageDescriptorPropType } from '../../prop-types/intl';
import { emptyArray } from 'ui-components/default-props/empty';
import { FiltersContext } from '../../filters/context';

import style from './bulk-update-menu.module.less';

const getMenuItems = (actions, ids, filters) =>
  actions.map(({ name, actionHandler, id, disabled }) => (
    <DropdownMenuItem key={id} disabled={disabled} onClick={() => actionHandler(ids, filters)}>
      <FormattedMessage {...name} />
    </DropdownMenuItem>
  ));

const BulkUpdateMenu = ({ actionSections = emptyArray, ids = emptyArray, optionsShouldBeDisabled, children = null, pendoTrackingId }) => {
  const { buildApiFilters } = useContext(FiltersContext) || {};
  const filters = buildApiFilters ? buildApiFilters() : null;
  return (
    <DropdownMenu disabled={optionsShouldBeDisabled} dropdownMenuClassName={style['dropdown-menu']} menuPosition='bottom-right'>
      <DropdownMenuToggler className={style['action-button']} pendoTrackingId={pendoTrackingId} theme='tertiary'>
        <FormattedMessage defaultMessage='Bulk Update' description='bulkUpdateMenu.bulkUpdate' id='K72/j/' />
      </DropdownMenuToggler>
      {children}
      {actionSections.map(({ sectionName, actions }) => (
        <div key={sectionName.id} className={style['action-section']}>
          {actionSections.length > 1 && (
            <div className={style['action-section-title']}>
              <FormattedMessage {...sectionName} />
            </div>
          )}
          {getMenuItems(actions, ids, filters)}
        </div>
      ))}
    </DropdownMenu>
  );
};

BulkUpdateMenu.propTypes = {
  actionSections: PropTypes.arrayOf(
    PropTypes.shape({
      sectionName: MessageDescriptorPropType,
      actions: PropTypes.arrayOf(
        PropTypes.shape({
          name: MessageDescriptorPropType,
          actionHandler: PropTypes.func,
          id: PropTypes.string,
          disabled: PropTypes.bool,
        }),
      ),
    }),
  ),
  ids: PropTypes.arrayOf(PropTypes.string),
  optionsShouldBeDisabled: PropTypes.bool.isRequired,
  children: PropTypes.node,
  pendoTrackingId: PropTypes.string,
};

export default BulkUpdateMenu;
